import React, { Component } from "react";
import { apiCalling, forceLogout, apiCallingWithoutToken } from "../apiService";
import "bootstrap/dist/css/bootstrap.css";
import "../css/slick.css";
import "../css/style.css";
import loaderImg from "../image/theme/loader.gif";
import { ClearBrowserCache } from "react-clear-browser-cache";
import { Helmet } from "react-helmet";
import { authHelper } from "../utilis/authHelper";
import {
  resolveThemeFolder,
  applyHospitalFooterToSession,
  parseGoogleAnalyticsIds,
  applyThemeSectionListToSession,
} from "./getSiteDetails";

export default class root extends Component {
  constructor(props) {
    super(props);
    this.state = {
      siteId: this.props.match.params.siteId,
      siteUrl: window.location.host,
      isLoader: false,
      urlRedirect: window.location.pathname,
      urlFlag: false,
    };
  }
  signOutPatientClick() {
    const logoutReq = {
      method: "POST",
      body: JSON.stringify({
        functionName: "logout",
        siteId: window.sessionStorage.getItem("logedSiteId"),
        userId: authHelper.getUserId(),
      }),
    };

    apiCalling(logoutReq).then((data) => {
      if (data.success === "1") {
        window.sessionStorage.setItem("userId", "");
        window.sessionStorage.setItem("emailId", "");
        window.sessionStorage.setItem("userName", "");
        window.sessionStorage.setItem("isLogin", "");
        window.sessionStorage.setItem("logedSiteId", "");
        const urlPath = window.location.origin.toString();
        window.location.href = urlPath + "/";
        forceLogout();
        authHelper.logout(true);
        //alert(data.successMessage);
      } else {
        //alert("Logout Failed");
      }
    });
  }
  componentDidMount() {
    sessionStorage.clear();
    //change siteurl ="www.doctorscabin.com" for doctors cabin changing here is enough
    let siteurl = ""; //this.state.siteUrl//""
    window.sessionStorage.setItem("pathname", window.location.pathname);
    if (!this.state.siteId) {
      // alert("if")
      siteurl = this.state.siteUrl;
    } else {
      //alert("else")
      //alert(window.location.host);
      //alert(window.location.pathname)
      //this.setState({urlFlag:true})
      //alert("else")
      // window.sessionStorage.setItem("pathname",'null')
    }

    //  window.sessionStorage.setItem("mysession","xxx")
    window.sessionStorage.setItem("siteId", this.state.siteId);
    if (
      this.state.siteId !== window.sessionStorage.getItem("logedSiteId") &&
      window.sessionStorage.getItem("logedSiteId") !== ""
    ) {
      // this.signOutPatientClick();
    }
    const loginRequest = {
      method: "POST",
      body: JSON.stringify({
        functionName: "getSiteDetails",
        siteId: this.state.siteId,
        siteUrl: siteurl,
      }),
    };
    // alert(loginRequest.body)
    apiCallingWithoutToken(loginRequest)
      .then((data) => {
        if (!data || String(data.success) !== "1") {
          console.error("getSiteDetails failed in root:", data);
          return;
        }

        const details = data.siteDetailsData?.[0];
        const siteData = details?.siteData?.[0];
        if (!siteData) {
          console.error("getSiteDetails: missing siteData");
          return;
        }

        const folder = resolveThemeFolder(siteData);
        window.sessionStorage.setItem(
          "siteId",
          siteData.id,
        );
        window.sessionStorage.setItem(
          "themeId",
          siteData.themeId,
        );
        window.sessionStorage.setItem(
          "themeName",
          siteData.themeName,
        );

        window.sessionStorage.setItem("themeVersion", "0");
        window.sessionStorage.setItem("homeName", folder);
        //  window.sessionStorage.setItem("homeName", "ida");
        window.sessionStorage.setItem("reload", "1");
        window.sessionStorage.setItem(
          "dashboard_html",
          siteData.dashboard_html,
        );
        window.sessionStorage.setItem(
          "theme_custom_color",
          siteData.theme_custom_color,
        );
        window.sessionStorage.setItem(
          "contact_emailId",
          siteData.emailId,
        );
        window.sessionStorage.setItem(
          "google_review_link",
          siteData.google_review_link,
        );
        window.sessionStorage.setItem(
          "contact_no",
          siteData.contact_no,
        );
        window.sessionStorage.setItem(
          "fav_icon",
          siteData.fav_icon,
        );
        window.sessionStorage.setItem(
          "seo_description",
          siteData.seo_description,
        );
        window.sessionStorage.setItem(
          "seo_keywords",
          siteData.seo_keywords,
        );
        window.sessionStorage.setItem(
          "seo_title",
          siteData.seo_title,
        );
        window.sessionStorage.setItem(
          "slug",
          siteData.slug,
        );
        window.sessionStorage.setItem(
          "isIDALogin",
          siteData.isIDALogin,
        );
        const { googleId, clarityId } = parseGoogleAnalyticsIds(
          siteData.google_analytics_script,
        );
        window.sessionStorage.setItem("clarityId", clarityId);
        window.sessionStorage.setItem("googleId", googleId);
        window.sessionStorage.setItem(
          "siteName",
          siteData.siteName,
        );
        window.sessionStorage.setItem(
          "book_appointment_terms",
          siteData.book_appointment_terms,
        );
        window.sessionStorage.setItem(
          "video_chat_terms",
          siteData.video_chat_terms,
        );
        window.sessionStorage.setItem(
          "hospital_working_time",
          siteData.hospital_working_time,
        );
        window.sessionStorage.setItem(
          "site_url",
          siteData.site_url,
        );
        window.sessionStorage.setItem(
          "title",
          siteData.title,
        );
        window.sessionStorage.setItem(
          "fbPixel",
          siteData.fbPixel,
        );
        window.sessionStorage.setItem(
          "advertisementScript",
          siteData.advertisementScript,
        );

        window.sessionStorage.setItem(
          "termsAndCondition",
          siteData.termsAndCondition,
        );
        window.sessionStorage.setItem(
          "privacyPolicy",
          siteData.privacyPolicy,
        );

        window.sessionStorage.setItem(
          "hasHealthTracker",
          siteData.hasHealthTracker,
        );
        window.sessionStorage.setItem(
          "siteLogo",
          siteData.logo_path,
        );
        window.sessionStorage.setItem(
          "groupHospitalAdminId",
          details.groupHospitalAdminData?.[0]?.groupHospitalAdminId ?? "",
        );
        window.sessionStorage.setItem(
          "headerData",
          JSON.stringify(details.headerData),
        );

        window.sessionStorage.setItem(
          "footerData",
          JSON.stringify(details.footerData),
        );

        window.sessionStorage.setItem(
          "siteServices",
          JSON.stringify(details.services ?? null),
        );
        applyHospitalFooterToSession(details);
        applyThemeSectionListToSession(details.themeSectionList);
        window.sessionStorage.setItem(
          "doctorDetails",
          JSON.stringify(details.doctorDetails),
        );

        window.location.href = "/";
      })
      .catch((err) => console.error("root getSiteDetails:", err));
  }
  render() {
    return (
      <div>
        <Helmet>
          <title></title>
          <meta http-equiv="cache-control" content="no-cache" />
          <meta http-equiv="expires" content="0" />
          <meta http-equiv="pragma" content="no-cache" />
        </Helmet>
        <ClearBrowserCache>{(contextValue) => null}</ClearBrowserCache>;
        {this.state.isLoader === false ? (
          <div
            style={{ padding: "30vh", textAlign: "center", display: "none" }}
          >
            <img src={loaderImg} alt="" />
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
